<div class="main-content mnt nsol table-page">
  <div class="container-fluid">

  <!-- En la lista de lo pedido de un tipo, el encabezado dice qué lista es
       y lleva «Regresar» a las tarjetas y el botón para pedir otra: un
       renglón menos que con una barra aparte. -->
  <section class="table-page__hero mnt-hero">
    <div class="table-page__copy mnt-hero__copy">
      <span class="material-icons mnt-hero__icono" aria-hidden="true">{{ encabezado.icono }}</span>
      <div class="mnt-hero__textos">
        <h1>{{ encabezado.titulo }}</h1>
        <p>{{ encabezado.ayuda }}</p>
      </div>
    </div>
    <!-- En el formulario de IA o de Mantenimiento, sus botones van aquí
         arriba, como en Capacitación (15/10/2026). Los trae el formulario. -->
    <div class="table-page__toolbar-actions nsol-acciones" *ngIf="accionesFormulario as acciones">
      <ng-container *ngTemplateOutlet="acciones"></ng-container>
    </div>
    <div class="table-page__toolbar-actions nsol-acciones" *ngIf="vista as o">
      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="volverATipo()">
        <span class="material-icons" aria-hidden="true">arrow_back</span>
        Regresar
      </button>
      <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" (click)="elegir(o)">
        <span class="material-icons" aria-hidden="true">add</span>
        {{ o.tarjetas[0].accion }}
      </button>
    </div>
  </section>

  <!-- Dónde va el asistente. Solo informa: se avanza con las tarjetas y
       con los botones de cada formulario. En las listas de lo pedido no
       va: ahí no se está pidiendo nada. -->
  <ol class="nsol-ruta" *ngIf="opciones.length && paso !== 'mias'" aria-label="Avance">
    <li *ngFor="let p of PASOS; let i = index"
        [class.es-actual]="p.id === paso"
        [class.es-hecho]="i < indice()">
      <span class="nsol-ruta__num" aria-hidden="true">
        <span class="material-icons" *ngIf="i < indice(); else num">check</span>
        <ng-template #num>{{ i + 1 }}</ng-template>
      </span>
      {{ p.texto }}
    </li>
  </ol>

  <!-- ==================== 1. ¿Qué necesitas? ==================== -->
  <!-- Las tarjetas, todas al mismo nivel: los cuatro tipos de ticket (cada uno abre SU formulario de siempre:
       Infraestructura y Mejoras, un diálogo; Perfil y Capacitación, su página en el módulo de Tickets), IA y
       Mantenimiento (su formulario, aquí mismo). -->
  <div class="nsol-inicio" *ngIf="paso === 'tipo'">
    <div class="nsol-opciones" [class.son-muchas]="tarjetas.length > 4" *ngIf="opciones.length; else sinOpciones">
      <button type="button" class="nsol-op" *ngFor="let t of tarjetas"
              [attr.data-tono]="t.tono" [class.nsol-op--mant]="mantenimientoDe(t)" (click)="abre(t)">
        <span class="nsol-op__cab">
          <span class="nsol-op__icono" aria-hidden="true">
            <span class="material-icons">{{ t.icono }}</span>
          </span>
          <span class="nsol-op__titulo">{{ t.titulo }}</span>
        </span>
        <span class="nsol-op__desc">{{ t.descripcion }}</span>
        <ul class="nsol-op__ej">
          <li *ngFor="let e of t.ejemplos">
            <span class="material-icons" aria-hidden="true">check</span>{{ e }}
          </li>
        </ul>
        <span class="nsol-op__ir" *ngIf="!mantenimientoDe(t); else enMant">
          {{ t.accion }}
          <span class="material-icons" aria-hidden="true">arrow_forward</span>
        </span>
        <ng-template #enMant>
          <span class="nsol-op__ir nsol-op__ir--mant">
            <span class="material-icons" aria-hidden="true">construction</span>
            En mantenimiento
          </span>
        </ng-template>
      </button>
    </div>

    <!-- Lo que ya pediste: un acceso por proceso (Tickets, IA y Mantenimiento), que dice cómo va (cuántas siguen en
         curso y cuántas esperan algo de ti). Tickets se sigue en su módulo; IA y Mantenimiento, aquí mismo. El acceso entero
         lleva a su lista (el enlace es su título, estirado sobre la tarjeta); el aviso ámbar es un enlace aparte y
         lleva directo a la que espera. -->
    <nav class="nsol-mias" *ngIf="opciones.length" aria-labelledby="nsol-mias-titulo">
      <h2 class="nsol-mias__titulo" id="nsol-mias-titulo">
        <span class="material-icons" aria-hidden="true">history</span>
        ¿Ya pediste algo? Ve cómo va
      </h2>
      <div class="nsol-mias__lista">
        <ng-container *ngFor="let o of opciones">
          <div class="nsol-mia" *ngIf="marcas[o.id] as m"
               [attr.data-tono]="o.id"
               [class.tiene-algo]="m.enCurso || m.pide"
               [class.te-espera]="m.pide">
            <span class="nsol-mia__icono" aria-hidden="true">
              <span class="material-icons">{{ o.icono }}</span>
            </span>
            <span class="nsol-mia__textos">
              <a class="nsol-mia__titulo"
                 [routerLink]="o.mias.ruta || []"
                 [queryParams]="o.mias.ver ? { ver: o.mias.ver } : null"
                 [attr.aria-describedby]="'nsol-mia-' + o.id">{{ o.mias.texto }}</a>
              <span class="nsol-mia__estado" [id]="'nsol-mia-' + o.id" [ngSwitch]="m.estado">
                <ng-container *ngSwitchCase="'listo'">
                  <a class="nsol-mia__pide" *ngIf="m.aLaQueEspera as d"
                     [routerLink]="d.ruta"
                     [queryParams]="d.consulta"
                     [attr.aria-label]="o.mias.texto + ': ' + m.pide">
                    {{ m.pide }}
                    <span class="material-icons" aria-hidden="true">arrow_forward</span>
                  </a>
                  <span class="nsol-mia__curso" *ngIf="m.enCurso">{{ m.enCurso }}</span>
                  <span class="nsol-mia__nada" *ngIf="!m.pide && !m.enCurso">Nada en curso</span>
                </ng-container>
                <span class="nsol-mia__nada" *ngSwitchCase="'sin-dato'">Ver cómo van</span>
                <span class="nsol-mia__consultando" *ngSwitchDefault aria-hidden="true"></span>
              </span>
            </span>
            <span class="material-icons nsol-mia__ir" aria-hidden="true">chevron_right</span>
          </div>
        </ng-container>
      </div>
    </nav>
  </div>

  <!-- ==================== 2. Tu solicitud ==================== -->
  <app-form-mantenimiento *ngIf="paso === 'form' && formulario === 'mantenimiento'"
                          (enviada)="alEnviarMantenimiento($event)"
                          (volver)="volverATipo()"></app-form-mantenimiento>

  <!-- IA: su componente de siempre. Es la MISMA instancia para pedir y
       para «Mis solicitudes de IA»: si faltó guardar algo, el reintento
       (que vive en memoria) sigue ahí. -->
  <app-solicitud-ia *ngIf="formulario === 'ia' && (paso === 'form' || paso === 'mias')"
                    [pestanaActiva]="pestanaIa"
                    [destacada]="destacadaIa"
                    (pestanaCambiada)="alCambiarPestanaIa($event)"
                    (enviada)="alEnviarIa($event)"
                    (volver)="volverATipo()"></app-solicitud-ia>

  <!-- ==================== Mis solicitudes de mantenimiento ==================== -->
  <app-mis-mantenimiento *ngIf="paso === 'mias' && formulario === 'mantenimiento'"></app-mis-mantenimiento>

  <!-- ==================== 3. Listo ==================== -->
  <section class="table-page__card nsol-listo" *ngIf="paso === 'listo' && resultado as r" aria-live="polite">
    <span class="nsol-listo__icono" aria-hidden="true"><span class="material-icons">task_alt</span></span>
    <h2 *ngIf="r.folio; else sinFolio">Listo, tu solicitud es la <b>{{ r.folio }}</b></h2>
    <ng-template #sinFolio><h2>Listo, tu solicitud quedó registrada</h2></ng-template>

    <ng-container [ngSwitch]="r.tipo">
      <p *ngSwitchCase="'mantenimiento'">Le llegó al equipo de mantenimiento. Te avisamos por correo cuando la tomen y cuando quede resuelta.</p>
      <p *ngSwitchCase="'ia'">
        <ng-container *ngIf="r.archivos">Va con {{ r.archivos === 1 ? 'un archivo' : r.archivos + ' archivos' }}. </ng-container>
        La revisa el equipo que evalúa las herramientas de IA. En «Mis solicitudes de IA» ves en qué va y si te piden algo.
      </p>
    </ng-container>

    <p class="nsol-listo__aviso" *ngIf="r.fotosFallidas.length">
      <span class="material-icons" aria-hidden="true">warning_amber</span>
      <span>
        No se pudieron subir {{ r.fotosFallidas.length === 1 ? 'una foto' : r.fotosFallidas.length + ' fotos' }}
        ({{ r.fotosFallidas.join(', ') }}). Puedes subirlas desde el detalle de la solicitud.
      </span>
    </p>

    <div class="nsol-listo__btns">
      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="volverATipo()">
        <span class="material-icons" aria-hidden="true">add</span>
        Pedir otra cosa
      </button>
      <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" (click)="verMiSolicitud()">
        <span class="material-icons" aria-hidden="true">visibility</span>
        Ver mi solicitud
      </button>
    </div>
  </section>

  <ng-template #sinOpciones>
    <section class="table-page__card">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">inbox</span>
        <h3>No tienes solicitudes disponibles</h3>
        <p>Tu perfil no incluye ninguna. Si necesitas pedir algo, habla con quien administra los perfiles.</p>
      </div>
    </section>
  </ng-template>
  </div>
</div>
